window.addEventListener('load', function () {
    const allCarousels = document.querySelectorAll('.wp-block-telex-block-carousel-row');

    allCarousels.forEach(carousel => {
        const track = carousel.querySelector('.carousel-track');
        const originalRow = track.querySelector('.carousel-row-content');

        if (!track || !originalRow) return;
        if (track.dataset.initialized) return;

        // --- CONFIGURATION ---
        let isReversed = carousel.classList.contains('carousel-reverse');
        const pauseOnHover = carousel.classList.contains('pause-on-hover');
        const baseSpeed = parseInt(carousel.dataset.animationSpeed) || 65;

        // --- ANIMATION STATE ---
        let allSlides = [];
        let numOriginalSlides = 0;
        let currentCentralSlide = null;
        let currentX = 0;
        let loopPoint = 0;
        let isPaused = false;
        let lastTime = null;
        let animationFrameId = null;
        let targetSpeed = baseSpeed;
        let currentSpeed = baseSpeed;
        const easingFactor = 0.05;
        let isDragging = false, startX = 0, scrollLeft = 0, velocity = 0, velocityTimestamp = 0;

        // --- HELPER FUNCTION ---
        function debounce(func, wait) {
            let timeout;
            return function executedFunction(...args) {
                const later = () => {
                    clearTimeout(timeout);
                    func(...args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        }

        // --- "TRIPLE CONTENT" SETUP ---
        function setupSlider() {
            cancelAnimationFrame(animationFrameId);
            
            // Create two clones of the original content
            const clone1 = originalRow.cloneNode(true);
            const clone2 = originalRow.cloneNode(true);
            clone1.classList.add('clone');
            clone2.classList.add('clone');

            // Arrange the track as [Clone 1] [Original] [Clone 2]
            track.prepend(clone1);
            track.appendChild(clone2);
            
            // Calculate the loop point (the width of one content block)
            loopPoint = originalRow.offsetWidth + (parseFloat(window.getComputedStyle(track).gap) || 0);

            // Set the initial position to the middle block
            currentX = -loopPoint;
            track.style.transform = `translateX(${currentX}px)`;

            // Refresh slide list for central slide logic
            allSlides = Array.from(carousel.querySelectorAll('.wp-block-image'));
            numOriginalSlides = originalRow.children.length;

            // Restart animation
            lastTime = null;
            animationFrameId = requestAnimationFrame(animationLoop);
        }

        function animationLoop(currentTime) {
            if (!lastTime) lastTime = currentTime;
            const deltaTime = currentTime - lastTime;
            lastTime = currentTime;

            if (!isDragging) {
                currentSpeed += (targetSpeed - currentSpeed) * easingFactor;
                if (Math.abs(currentSpeed) < 0.1) currentSpeed = 0;

                if (velocity !== 0) { // Coasting
                    const deceleration = 0.95;
                    currentX += velocity;
                    velocity *= deceleration;
                    if (Math.abs(velocity) < 0.5) {
                        velocity = 0;
                        if (!pauseOnHover || !carousel.matches(':hover')) targetSpeed = baseSpeed;
                    }
                } else { // Auto-scroll
                    const direction = isReversed ? 1 : -1;
                    currentX += direction * (currentSpeed / 1000) * deltaTime;
                }
            }

            // "Asteroids" loop logic for the triple content structure
            if (loopPoint > 0) {
                // If scrolled too far right (into the first clone)
                if (currentX > -loopPoint) {
                    currentX -= loopPoint;
                }
                // If scrolled too far left (into the second clone)
                if (currentX < -loopPoint * 2) {
                    currentX += loopPoint;
                }
            }

            track.style.transform = `translateX(${currentX}px)`;
            animationFrameId = requestAnimationFrame(animationLoop);
        }

        function updateCentralSlide() {
            const sliderRect = carousel.getBoundingClientRect();
            const sliderCenter = sliderRect.left + sliderRect.width / 2;
            let closestDistance = Infinity;
            let newCentralSlide = null;
            allSlides.forEach(slide => {
                const slideRect = slide.getBoundingClientRect();
                if (slideRect.right < sliderRect.left || slideRect.left > sliderRect.right) return;
                const slideCenter = slideRect.left + slideRect.width / 2;
                const distance = Math.abs(sliderCenter - slideCenter);
                if (distance < closestDistance) {
                    closestDistance = distance;
                    newCentralSlide = slide;
                }
            });
            if (newCentralSlide && newCentralSlide !== currentCentralSlide) {
                if (currentCentralSlide) allSlides.forEach(s => s.classList.remove('most-central'));
                const newIndex = allSlides.indexOf(newCentralSlide) % numOriginalSlides;
                for (let i = newIndex; i < allSlides.length; i += numOriginalSlides) {
                    if(allSlides[i]) allSlides[i].classList.add('most-central');
                }
                currentCentralSlide = newCentralSlide;
            }
        }
        
        function onPointerDown(e) { isDragging = true; velocity = 0; targetSpeed = 0; currentSpeed = 0; startX = e.pageX || e.touches[0].pageX; scrollLeft = currentX; velocityTimestamp = performance.now(); carousel.classList.add('is-dragging'); e.preventDefault(); }
        function onPointerMove(e) { if (!isDragging) return; const x = e.pageX || e.touches[0].pageX; const walk = x - startX; const newX = scrollLeft + walk; const now = performance.now(); const timeDelta = now - velocityTimestamp; const distanceDelta = newX - currentX; if (timeDelta > 0) { velocity = (distanceDelta / timeDelta) * 16.67; } velocityTimestamp = now; currentX = newX; }
        function onPointerUp() {
            if (!isDragging) return;
            isDragging = false;
            carousel.classList.remove('is-dragging');
            if (Math.abs(velocity) > 1) isReversed = velocity > 0;
            if (velocity === 0 && (!pauseOnHover || !carousel.matches(':hover'))) targetSpeed = baseSpeed;
        }

        if (pauseOnHover) {
            carousel.addEventListener('mouseenter', () => { if (!isDragging) targetSpeed = 0; });
            carousel.addEventListener('mouseleave', () => targetSpeed = baseSpeed);
        }
        
        track.addEventListener('pointerdown', onPointerDown);
        window.addEventListener('pointermove', onPointerMove);
        window.addEventListener('pointerup', onPointerUp);
        window.addEventListener('pointercancel', onPointerUp);
        
        // We no longer need the resize handler as the triple-content structure is inherently robust
        
        // --- INITIALIZATION ---
        setupSlider();
        track.dataset.initialized = 'true';
        setInterval(updateCentralSlide, 200);
    });
});